import option from './option'

const plan = {
  option,
}

export default plan
